module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_primærlogo_sentrert_logo_neg.366cac8a.png";